var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-page',{staticClass:"show-settings-directories",attrs:{"show":_vm.show},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var formProcessing = ref.formProcessing;
var onSubmit = ref.onSubmit;
return [_c('directories',{attrs:{"show":_vm.show,"form-processing":formProcessing,"player-embed":_vm.playerEmbed},on:{"submit":onSubmit}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }